export { default } from './NewsBanner'
export * from './NewsBanner.styles'
